module.exports = __webpack_public_path__ + "static/media/equinix.2892be87.png";